import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useCurrentSalesOrderContractTask } from '@/providers/SalesOrderContractTaskProvider';
import { SalesOrderContractTaskFileEditForm } from '@/components/features/tasks/sales_order_contract/[sales_order_contract_task_id]/SalesOrderContractTaskFileEditForm';

export const ApprovalSalesOrderContractTaskFiles = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`Approval - Files`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `Approval`, path: `/w/${_w_!.identifier}/approval` },
        {
          label: `Approval - Sales Order Contract Task Detail`,
          path: `/w/${_w_!.identifier}/approval/teams/${_t_!.id}/sales_orders/${_so_!.id}/sales_order_contract_tasks/${task!.id}`,
        },
      ]),
    []
  );

  const { _so_ } = useCurrentSalesOrder();
  const { salesOrderContractTask: task } = useCurrentSalesOrderContractTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <SalesOrderContractTaskFileEditForm />
    </WorkspaceLayout>
  );
};
